import PropTypes from 'prop-types';
import React from 'react';
var propTypes = {
  label: PropTypes.string
};
var Loader = function Loader(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Loading...' : _ref$label;
  return /*#__PURE__*/React.createElement("div", {
    className: "rbt-loader spinner-border spinner-border-sm",
    role: "status"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only visually-hidden"
  }, label));
};
Loader.propTypes = propTypes;
export default Loader;